import React from "react";
import { Header } from "./header";
import { Footer } from "./footer";
import { Outlet } from "react-router";
import Sidebar from './Sidebar';
import { Modals } from "components/Modal";

const Layout = () => {

  return (
    <>
      <Header />
      <Sidebar />
      <Outlet />
      <Footer />
      <Modals />
    </>
  );
};

export default Layout;
